import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, fields } from '../../../../src/helpers/LinkMapper';

const fieldSchema = {
    number: [ fields.string ],
    type: [ fields.string ],
    price: [ fields.number ],
    photocardNumber: [ fields.string ],
    smartcardNumber: [ fields.string ],
    previousUpload: [ fields.bool ],
    receiptImageId: [ fields.number ],
    receiptImage: [ fields.string ],
    ticketImageId: [ fields.number ],
    ticketImage: [ fields.string ],
    ticketClass: [ fields.string ],
    purchaseLocation: [ fields.string ],
    purchaseStation: [ fields.string ], // NLC
    purchaseOther: [ fields.string ]
};

export default class DelayRepayTicket extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(DelayRepayTicket, json, getResolvers(fieldSchema));
    }
}
